import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import ClickSearchCategoryNormalizersResolver from "./ClickSearchCategoryNormalizersResolver";
export default class ClickSearchCategoryDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new ClickSearchCategoryNormalizersResolver());
        }
        return this.builderInstance;
    }
}
